var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoodNotGoodIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#9FADF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 14.7773C15.625 13.6555 16.5344 12.7461 17.6562 12.7461C18.7781 12.7461 19.6875 13.6555 19.6875 14.7773V18.8398C19.6875 19.9617 18.7781 20.8711 17.6562 20.8711C16.5344 20.8711 15.625 19.9617 15.625 18.8398V14.7773Z",
    fill: "#4C555F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6875 14.7773C32.6875 13.6555 33.5969 12.7461 34.7188 12.7461C35.8406 12.7461 36.75 13.6555 36.75 14.7773V18.8398C36.75 19.9617 35.8406 20.8711 34.7188 20.8711C33.5969 20.8711 32.6875 19.9617 32.6875 18.8398V14.7773Z",
    fill: "#4C555F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8629 36.7483C40.241 37.6714 39.81 38.7316 38.8999 39.1156C38.6763 39.2092 38.4445 39.2539 38.2162 39.2539C37.5171 39.2539 36.8536 38.8343 36.5688 38.1369C34.9179 34.1001 30.829 31.493 26.1515 31.493C21.5798 31.493 17.5146 34.1019 15.7954 38.1412C15.4042 39.0595 14.3543 39.4827 13.4507 39.0848C12.547 38.687 12.1309 37.6213 12.5221 36.7036C14.8067 31.3378 20.1572 27.871 26.1521 27.871C32.2754 27.871 37.6574 31.3548 39.8629 36.7483Z",
    fill: "#4C555F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodNotGoodIcon);
export default __webpack_public_path__ + "static/media/MoodNotGoodIcon.65ac1d7cab2648ecdc016d47c90caa10.svg";
export { ForwardRef as ReactComponent };